import { render, staticRenderFns } from "./MasterList.vue?vue&type=template&id=6ac8d968"
import script from "./MasterList.vue?vue&type=script&lang=js"
export * from "./MasterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports